var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    className: "streamline-favourite_svg__cls-2",
    d: "M20.65 10.4l3 5.89 5.72.57a.72.72 0 01.66.77.76.76 0 01-.21.45l-4.71 4.67 1.74 6.34a.72.72 0 01-.51.89.75.75 0 01-.51-.06L20 27.05l-5.8 2.87a.72.72 0 01-1-.32.7.7 0 01-.05-.51l1.75-6.35-4.72-4.67a.71.71 0 010-1 .76.76 0 01.45-.21l5.72-.56 3-5.89a.73.73 0 011-.32.71.71 0 01.3.31z"
  })));
}
export default SvgStreamlineFavourite;